// extracted by mini-css-extract-plugin
export default {"button":"ThumbAction-module__button--c1d82"};